/**
 * Bug Report Button Component
 * Floating button in bottom-right corner that opens the bug report modal
 */

import React, { useState } from 'react';
import BugReportModal from './BugReportModal';
import './BugReportButton.css';

const BugReportButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button
        className="bug-report-button"
        onClick={handleOpenModal}
        title="Report a Bug"
        aria-label="Report a Bug"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="24"
          height="24"
        >
          {/* Bug icon */}
          <path d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.66-.1-.65C8.03 15.47 8 15.22 8 15v-4c0-2.21 1.79-4 4-4s4 1.79 4 4z"/>
        </svg>
      </button>

      {isModalOpen && <BugReportModal onClose={handleCloseModal} />}
    </>
  );
};

export default BugReportButton;
